module.exports = __webpack_public_path__ + "img/dawbg.b27adfb8.gif";